<template>
	<!-- 买家情况面板: 芝麻接待会话右侧实时画像。
	     铁律: 字段为 null = 没查到, 整行隐藏, 绝不兜 0 (0%完成率是重度警示)。 -->
	<div class="chat-buyer-profile-side">
		<div class="bp-head">
			<span class="bp-title">买家情况</span>
			<span class="bp-refresh el-icon-refresh" :class="{ spinning: loading }" title="刷新实时数据"
				@click="load()"></span>
		</div>

		<div class="bp-tabs">
			<div v-for="t in tabs" :key="t.key" class="bp-tab"
				:class="{ active: activeTab === t.key }" @click="activeTab = t.key">
				{{ t.title }}
			</div>
		</div>

		<el-scrollbar class="bp-scroll">
			<!-- 广告/评价: 芝麻开放接口无此数据源, 如实显示暂无数据, 不伪造计数 -->
			<div v-if="activeTab !== 'detail'" class="bp-empty">{{ activeTab === 'ad' ? '暂无广告数据' : '暂无评价数据' }}</div>

			<template v-else>
				<div v-if="loading && !data" class="bp-empty">正在获取实时画像...</div>
				<div v-else-if="error" class="bp-empty bp-error">
					<i class="el-icon-warning-outline"></i>
					<span>{{ error }}</span>
					<el-button size="mini" type="text" @click="load()">重试</el-button>
				</div>
				<div v-else-if="data" class="bp-body">
					<!-- 总成单 / 买入(红) / 卖出(绿), 竖条长度按占比 -->
					<div class="bp-card">
						<div class="bp-big-row">
							<span class="bp-label">总成单</span>
							<span class="bp-big-num">{{ num(p.complete_transactions) }}</span>
						</div>
						<div class="bp-bar-row" v-if="num(p.paid_transactions) !== null">
							<span class="bp-label">买入</span>
							<span class="bp-val">{{ num(p.paid_transactions) }}</span>
							<span class="bp-bar"><i class="bp-bar-fill bp-bar-red"
								:style="{ width: barPct(num(p.paid_transactions)) }"></i></span>
						</div>
						<div class="bp-bar-row" v-if="num(p.accepted_transactions) !== null">
							<span class="bp-label">卖出</span>
							<span class="bp-val">{{ num(p.accepted_transactions) }}</span>
							<span class="bp-bar"><i class="bp-bar-fill bp-bar-green"
								:style="{ width: barPct(num(p.accepted_transactions)) }"></i></span>
						</div>
					</div>

					<!-- 完成率(30天口径), 低于50/80挂风险标 -->
					<div class="bp-card" v-if="num(p.complete_rate_month) !== null">
						<div class="bp-bar-row">
							<span class="bp-label">完成率</span>
							<span class="bp-val bp-val-rate" :class="rateClass(num(p.complete_rate_month))">
								{{ num(p.complete_rate_month).toFixed(2) }}%
								<em v-if="rateTag(num(p.complete_rate_month))" class="bp-rate-tag">{{ rateTag(num(p.complete_rate_month)) }}</em>
							</span>
							<span class="bp-bar"><i class="bp-bar-fill bp-bar-blue"
								:style="{ width: Math.min(num(p.complete_rate_month), 100) + '%' }"></i></span>
						</div>
						<div class="bp-bar-row" v-if="num(p.orders_buy_rate_month) !== null">
							<span class="bp-label">买入</span>
							<span class="bp-val">{{ num(p.orders_buy_rate_month).toFixed(2) }}%</span>
							<span class="bp-bar"><i class="bp-bar-fill bp-bar-red"
								:style="{ width: Math.min(num(p.orders_buy_rate_month), 100) + '%' }"></i></span>
						</div>
					</div>

					<div class="bp-divider"></div>

					<!-- 交易行为组 -->
					<div class="bp-rows">
						<div class="bp-row" v-if="tradeType">
							<span class="bp-label">交易类型</span>
							<span class="bp-row-val">{{ tradeType }}</span>
						</div>
						<div class="bp-row" v-if="num(p.complete_transactions_month) !== null">
							<span class="bp-label">30日成单</span>
							<span class="bp-row-val">{{ num(p.complete_transactions_month) }}</span>
						</div>
						<div class="bp-row" v-if="num(p.transactions_used_time) !== null">
							<span class="bp-label">平均用时</span>
							<span class="bp-row-val">{{ num(p.transactions_used_time) }}分</span>
						</div>
						<div class="bp-row" v-if="num(p.cancelled_used_time_month) !== null">
							<span class="bp-label">30日平均取消</span>
							<span class="bp-row-val">{{ num(p.cancelled_used_time_month) }}分</span>
						</div>
					</div>

					<div class="bp-divider" v-if="num(p.registration_days) !== null || num(p.counterparties_num) !== null"></div>

					<!-- 账号资历组 -->
					<div class="bp-rows">
						<div class="bp-row" v-if="num(p.registration_days) !== null">
							<span class="bp-label">创建时长</span>
							<span class="bp-row-val">{{ num(p.registration_days) }}天</span>
						</div>
						<div class="bp-row" v-if="num(p.first_trade_days) !== null">
							<span class="bp-label">首次交易</span>
							<span class="bp-row-val">{{ num(p.first_trade_days) }}天</span>
						</div>
						<div class="bp-row" v-if="num(p.counterparties_num) !== null">
							<span class="bp-label">交易对手数量</span>
							<span class="bp-row-val">{{ num(p.counterparties_num) }}</span>
						</div>
					</div>

					<!-- 风险警示: 只在确实需要留神时出现 -->
					<div class="bp-warn" v-if="warns.length">
						<i class="el-icon-warning"></i>
						<span>{{ warns.join(' / ') }}</span>
					</div>

					<div class="bp-foot">实时数据 · {{ data.profileTime }}</div>
				</div>

				<!-- 当前订单信息: 独立于画像成功与否,会话关联的最新订单实时展示 -->
				<div class="bp-body" v-if="order">
					<div class="bp-divider"></div>
					<div class="bp-order">
						<div class="bp-order-head">
							<span class="bp-order-title">当前订单</span>
							<span class="bp-order-head-right">
								<!-- 待分配且财务/管理员在场: 临时会话里直接分配,不用再回上粉群 -->
								<el-button v-if="canAssign" type="primary" size="mini" @click="openAssign()">分配</el-button>
								<span class="bp-order-st" :class="orderStClass">{{ orderStText }}</span>
							</span>
						</div>
						<div class="bp-row">
							<span class="bp-label">订单号</span>
							<span class="bp-row-val bp-order-txid">{{ order.orderTxid || '-' }}</span>
						</div>
						<div class="bp-row">
							<span class="bp-label">金额</span>
							<span class="bp-row-val">{{ orderAmt }}</span>
						</div>
						<div class="bp-row" v-if="order.payChannelText">
							<span class="bp-label">支付方式</span>
							<span class="bp-row-val">{{ order.payChannelText }}</span>
						</div>
						<div class="bp-row" v-if="order.createdTime">
							<span class="bp-label">下单时间</span>
							<span class="bp-row-val">{{ order.createdTime }}</span>
						</div>
						<div class="bp-row" v-if="order.salespersonName">
							<span class="bp-label">接待人</span>
							<span class="bp-row-val">{{ order.salespersonName }}</span>
						</div>
						<div class="bp-row" v-if="order.buyerPaid === false">
							<span class="bp-label">买家付款</span>
							<span class="bp-row-val bp-order-unpaid">未付款</span>
						</div>
						<div class="bp-row" v-else-if="order.buyerPaid === true">
							<span class="bp-label">买家付款</span>
							<span class="bp-row-val bp-order-paid">已付款</span>
						</div>
					</div>
				</div>
				<div class="bp-body" v-else-if="orderLoaded">
					<div class="bp-divider"></div>
					<div class="bp-order-none">该买家暂无关联订单</div>
				</div>
			</template>
		</el-scrollbar>

		<!-- 分配弹窗: 与上粉群订单面板同口径(手机号/候选号码/业务员接单模式标签/老客默认选中) -->
		<el-dialog title="分配订单给业务员" :visible.sync="assignDialog.visible" width="360px" append-to-body>
			<div class="dlg-line"><label>订单</label><span>{{ order && order.orderTxid }}</span></div>
			<div class="dlg-line"><label>金额</label><span>{{ orderAmt }}</span></div>
			<div class="dlg-line">
				<!-- 微信单免填:微信单走二维码/微信号链路不需要手机号;支付宝单必填(2026-08-29商用定制可放开必填) -->
				<label><i v-if="!isWechatOrder && configStore.features.assignPhoneRequired" class="dlg-req">*</i>买家手机号<span v-if="isWechatOrder || !configStore.features.assignPhoneRequired" class="dlg-opt">（可不填）</span></label>
				<el-input v-model="assignDialog.buyerPhone" size="small" maxlength="20"
					placeholder="买家验证实名的手机号" style="width:220px"></el-input>
			</div>
			<!-- 聊天记录识别出的候选手机号:点击填充,可继续手改;买家刚发的号码未同步到时点"刷新"重扫 -->
			<div class="dlg-line">
				<label>识别号码</label>
				<span class="dlg-phone-cands" v-if="assignDialog.phones && assignDialog.phones.length">
					<span v-for="p in assignDialog.phones" :key="p" class="dlg-phone-cand"
						:class="{active: assignDialog.buyerPhone === p}" @click="assignDialog.buyerPhone = p">{{ p }}</span>
				</span>
				<span v-else style="color:#909399;font-size:12px">暂未识别到</span>
				<el-button type="text" size="mini" style="margin-left:8px;padding:0" @click="loadPhones(false)">刷新</el-button>
			</div>
			<div class="dlg-line">
				<label>业务员</label>
				<el-select v-model="assignDialog.salespersonId" placeholder="请选择业务员" size="small" style="width:220px">
					<!-- 后端只返回接单中的业务员;标签区分接单模式,支持微信+支付宝并存 -->
					<el-option v-for="m in assignDialog.members" :key="m.userId"
						:label="memberPayLabel(m)"
						:value="m.userId"></el-option>
				</el-select>
			</div>
			<div class="dlg-tip" v-if="assignDialog.suggestName" style="color:#e6a23c">
				老客户：此前由【{{ assignDialog.suggestName }}】接待过，已默认选中，特殊情况可手动更换
			</div>
			<div class="dlg-tip">分配后该订单将出现在业务员的订单面板，系统会自动给买家发接单消息。</div>
			<span slot="footer">
				<el-button size="small" @click="assignDialog.visible = false">取消</el-button>
				<el-button type="primary" size="small" :loading="assignDialog.submitting" @click="doAssign()">确认分配</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import bizApi from '../../api/bizApi.js';

export default {
	name: 'chatBuyerProfileSide',
	props: {
		buyerUserId: {
			type: [Number, String],
			required: true
		}
	},
	data() {
		return {
			activeTab: 'detail',
			tabs: [
				{ key: 'detail', title: '详情' },
				{ key: 'ad', title: '广告' },
				{ key: 'rate', title: '评价' }
			],
			loading: false,
			error: '',
			data: null,
			order: null, // 当前订单(会话关联的最新收据),实时查不走画像缓存
			orderLoaded: false,
			// 分配弹窗: 与上粉群订单面板同结构
			assignDialog: { visible: false, members: [], salespersonId: '', suggestName: '', buyerPhone: '', phones: [], submitting: false }
		};
	},
	computed: {
		p() {
			return (this.data && this.data.profile) || {};
		},
		// 交易类型: 芝麻 trade_versatile=true 为复合用户; false 时按买/卖多寡判断
		tradeType() {
			const v = this.p.trade_versatile;
			if (v === true || v === 'true') {
				return '复合用户';
			}
			if (v === false || v === 'false') {
				const buy = this.num(this.p.paid_transactions);
				const sell = this.num(this.p.accepted_transactions);
				if (buy === null && sell === null) return null;
				return (buy || 0) >= (sell || 0) ? '买入用户' : '卖出用户';
			}
			return null;
		},
		warns() {
			const list = [];
			if (this.bool(this.p.have_traded) === false) list.push('从未与我方成交');
			if (this.bool(this.p.is_risk_user) === true) list.push('芝麻标记风险用户');
			if (this.bool(this.p.verified) === false) list.push('未实名');
			return list;
		},
		// 订单状态文案/色调: 与订单看板口径一致
		orderStText() {
			const map = { '-1': '已取消', 0: '待分配', 1: '待确认收款', 2: '待放行', 3: '已放行', 4: '待财务确认', 5: '完结' };
			const st = this.order && this.order.flowStatus;
			return map[st] != null ? map[st] : '-';
		},
		orderStClass() {
			const st = this.order && this.order.flowStatus;
			if (st === -1) return 'st-cancel';
			if (st === 3 || st === 5) return 'st-done';
			return 'st-ing';
		},
		// 金额: 币数量 / 法币数量,缺哪个省哪个
		orderAmt() {
			if (!this.order) return '-';
			const crypto = this.order.cryptoAmount != null ? `${this.order.cryptoAmount} ${this.order.cryptoType || 'U'}` : '';
			const fiat = this.order.amount != null ? `${this.order.amount} ${this.order.fiat || 'CNY'}` : '';
			return [crypto, fiat].filter(Boolean).join(' / ') || '-';
		},
		// 待分配 + 财务/管理员身份才出分配按钮(后端 assign 同样硬校验)
		canAssign() {
			return !!(this.order && this.order.flowStatus === 0
				&& this.userStore && this.userStore.isBizFinance);
		},
		// 微信支付订单判定:payChannel=1 为微信单,分配时免填买家手机号
		isWechatOrder() {
			return !!(this.order && this.order.payChannel === 1);
		}
	},
	watch: {
		buyerUserId: {
			handler() {
				this.load();
				this.loadOrder();
			},
			immediate: true
		}
	},
	methods: {
		// null=没查到(隐藏); 绝不兜0, 0与没查到是两种完全不同的信号
		num(v) {
			if (v === null || v === undefined || v === '') return null;
			const n = Number(v);
			return isNaN(n) ? null : n;
		},
		bool(v) {
			if (v === true || v === 'true' || v === 1 || v === '1') return true;
			if (v === false || v === 'false' || v === 0 || v === '0') return false;
			return null;
		},
		// 买入/卖出条长度: 相对总成单占比, 总成单缺失时相对两者之和
		barPct(n) {
			const total = this.num(this.p.complete_transactions)
				|| ((this.num(this.p.paid_transactions) || 0) + (this.num(this.p.accepted_transactions) || 0));
			if (!total || n === null) return '0%';
			return Math.min(Math.round(n * 100 / total), 100) + '%';
		},
		rateTag(rate) {
			if (rate === null) return '';
			if (rate < 50) return '极低';
			if (rate < 80) return '偏低';
			return '';
		},
		rateClass(rate) {
			if (rate === null) return '';
			if (rate < 50) return 'rate-danger';
			if (rate < 80) return 'rate-warn';
			return 'rate-good';
		},
		async load() {
			if (!this.buyerUserId || this.loading) return;
			this.loading = true;
			this.error = '';
			this.loadOrder(); // 刷新按钮: 画像与订单一起拉
			try {
				const data = await this.$http({
					url: `/biz/gate/buyer/profile?buyerUserId=${this.buyerUserId}`,
					method: 'GET'
				});
				this.data = data || null;
				if (!this.data || !this.data.profile) {
					this.error = '未获取到买家画像';
				}
			} catch (e) {
				this.error = (e && e.message) || '获取买家画像失败';
			} finally {
				this.loading = false;
			}
		},
		// 当前订单: 后端无关联订单返回null,前端展示"暂无关联订单"
		async loadOrder() {
			if (!this.buyerUserId) return;
			try {
				const d = await this.$http({
					url: `/biz/gate/buyer/current-order?buyerUserId=${this.buyerUserId}`,
					method: 'GET'
				});
				this.order = d || null;
			} catch (e) {
				this.order = null;
			} finally {
				this.orderLoaded = true;
			}
		},
		// 打开分配弹窗: 按商户拉候选业务员(临时会话无群上下文),老客预选上次接待人,候选手机号自动填充
		openAssign() {
			if (!this.order) return;
			this.assignDialog.salespersonId = '';
			this.assignDialog.suggestName = '';
			this.assignDialog.buyerPhone = '';
			this.assignDialog.phones = [];
			this.assignDialog.members = [];
			this.assignDialog.visible = true;
			this.loadPhones(true);
			bizApi.merchantMembersForAssign(this.order.merchantId).then((list) => {
				this.assignDialog.members = list || [];
				return bizApi.suggestSales(this.order.receiptId).then((sug) => {
					if (!sug || !sug.salespersonId) return;
					const hit = this.assignDialog.members.find((m) => m.userId === sug.salespersonId);
					if (hit) {
						this.assignDialog.salespersonId = sug.salespersonId;
						this.assignDialog.suggestName = hit.nickName || sug.salespersonName;
					}
				});
			}).catch(() => { });
		},
		// 候选手机号重扫: openAssign 首次自动填充,弹窗内"刷新"按钮手动重拉(买家刚发的号码同步入库后补填)
		loadPhones(autoFill) {
			if (!this.order) return;
			bizApi.receiptPhones(this.order.receiptId).then((phones) => {
				this.assignDialog.phones = phones || [];
				if (autoFill && this.assignDialog.phones.length && !this.assignDialog.buyerPhone) {
					this.assignDialog.buyerPhone = this.assignDialog.phones[0];
				}
			}).catch(() => { });
		},
		// 接单模式标签:微信+支付宝可同时开启,兼容旧字段 payMode
		memberPayLabel(m) {
			const ali = m.alipayOk === true || m.payMode === 'alipay';
			const wx = m.wechatOk === true || m.payMode === 'wechat';
			if (ali && wx) return m.nickName + '（支付宝+微信）';
			if (wx) return m.nickName + '（微信接单）';
			return m.nickName + '（支付宝接单）';
		},
		doAssign() {
			if (this.configStore.features.assignPhoneRequired && !this.isWechatOrder && (!this.assignDialog.buyerPhone || !this.assignDialog.buyerPhone.trim())) {
				this.$message.warning('请填写买家验证实名的手机号');
				return;
			}
			if (!this.assignDialog.salespersonId) {
				this.$message.warning('请选择业务员');
				return;
			}
			this.assignDialog.submitting = true;
			// 临时会话无群上下文不传groupId: 后端兜底定向到业务员所在业务群,后续通知不漏
			bizApi.assign(this.order.receiptId, this.assignDialog.salespersonId, null, null, (this.assignDialog.buyerPhone || '').trim()).then(() => {
				this.$message.success('已分配');
				this.assignDialog.visible = false;
				this.loadOrder();
			}).catch(() => { }).finally(() => { this.assignDialog.submitting = false; });
		}
	}
};
</script>

<style lang="css" scoped>
.chat-buyer-profile-side {
	height: 100%;
	display: flex;
	flex-direction: column;
	background: var(--im-bg-color, #fff);
}

.bp-head {
	flex-shrink: 0;
	height: 44px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 16px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.bp-title {
	font-size: 15px;
	font-weight: 600;
	color: var(--im-text-color, #333);
}

.bp-refresh {
	cursor: pointer;
	font-size: 15px;
	color: var(--im-text-color-light, #999);
}

.bp-refresh:hover {
	color: var(--im-color-primary, #409eff);
}

.bp-refresh.spinning {
	animation: bp-spin 1s linear infinite;
}

@keyframes bp-spin {
	from { transform: rotate(0deg); }
	to { transform: rotate(360deg); }
}

.bp-tabs {
	flex-shrink: 0;
	display: flex;
	align-items: stretch;
	padding: 0 8px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.bp-tab {
	position: relative;
	padding: 10px 14px;
	cursor: pointer;
	font-size: 13px;
	color: var(--im-text-color-light, #999);
}

.bp-tab.active {
	color: var(--im-color-primary, #409eff);
	font-weight: 600;
}

.bp-tab.active::after {
	content: '';
	position: absolute;
	left: 14px;
	right: 14px;
	bottom: 0;
	height: 2px;
	border-radius: 1px;
	background: var(--im-color-primary, #409eff);
}

.bp-scroll {
	flex: 1;
}

.bp-empty {
	padding: 60px 20px;
	text-align: center;
	color: var(--im-text-color-light, #999);
	font-size: 13px;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 6px;
}

.bp-empty i {
	font-size: 26px;
}

.bp-error {
	color: #ff6b6b;
}

.bp-body {
	padding: 12px;
}

.bp-card {
	padding: 12px 14px;
	margin-bottom: 10px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	border-radius: 8px;
	background: var(--im-bg-color-card, rgba(0, 0, 0, 0.02));
}

.bp-big-row {
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	margin-bottom: 10px;
}

.bp-big-num {
	font-size: 26px;
	font-weight: 700;
	color: var(--im-text-color, #333);
	line-height: 1;
}

.bp-bar-row {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 8px;
}

.bp-bar-row:first-child {
	margin-top: 0;
}

.bp-label {
	flex-shrink: 0;
	width: 76px;
	font-size: 12px;
	color: var(--im-text-color-light, #999);
}

.bp-val {
	flex-shrink: 0;
	min-width: 44px;
	font-size: 13px;
	font-weight: 600;
	color: var(--im-text-color, #333);
}

.bp-val-rate {
	display: flex;
	align-items: center;
	gap: 6px;
}

.rate-danger {
	color: #ff6b6b;
}

.rate-warn {
	color: #ffa940;
}

.rate-good {
	color: #52c41a;
}

.bp-rate-tag {
	font-style: normal;
	font-size: 11px;
	font-weight: 700;
	padding: 1px 5px;
	border-radius: 3px;
	background: rgba(255, 107, 107, 0.12);
	color: #ff6b6b;
}

.rate-warn .bp-rate-tag {
	background: rgba(255, 169, 64, 0.12);
	color: #ffa940;
}

.bp-bar {
	flex: 1;
	height: 6px;
	border-radius: 3px;
	background: rgba(0, 0, 0, 0.06);
	overflow: hidden;
}

.bp-bar-fill {
	display: block;
	height: 100%;
	border-radius: 3px;
	transition: width 0.4s ease;
}

.bp-bar-red {
	background: linear-gradient(90deg, #ff7875, #ff4d4f);
}

.bp-bar-green {
	background: linear-gradient(90deg, #73d13d, #52c41a);
}

.bp-bar-blue {
	background: linear-gradient(90deg, #69b1ff, #409eff);
}

.bp-divider {
	height: 1px;
	margin: 4px 0 8px;
	background: rgba(0, 0, 0, 0.06);
}

.bp-rows {
	padding: 0 2px;
}

.bp-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 7px 0;
}

.bp-row .bp-label {
	width: auto;
	font-size: 13px;
}

.bp-row-val {
	font-size: 13px;
	font-weight: 600;
	color: var(--im-text-color, #333);
}

.bp-warn {
	margin-top: 10px;
	padding: 8px 12px;
	border-radius: 6px;
	background: rgba(255, 107, 107, 0.1);
	color: #ff6b6b;
	font-size: 12px;
	font-weight: 700;
	display: flex;
	align-items: center;
	gap: 6px;
}

.bp-foot {
	margin-top: 10px;
	text-align: right;
	font-size: 11px;
	color: var(--im-text-color-lighter, #bbb);
}

/* 当前订单板块 */
.bp-order {
	padding: 10px 12px;
	border: 1px solid rgba(0, 0, 0, 0.06);
	border-radius: 8px;
	background: var(--im-bg-color-card, rgba(0, 0, 0, 0.02));
}

.bp-order-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 6px;
}

.bp-order-head-right {
	display: flex;
	align-items: center;
	gap: 6px;
}

.bp-order-title {
	font-size: 13px;
	font-weight: 700;
	color: var(--im-text-color, #333);
}

.bp-order-st {
	font-size: 12px;
	font-weight: 600;
	padding: 1px 8px;
	border-radius: 10px;
}

.bp-order-st.st-ing {
	background: rgba(64, 158, 255, 0.12);
	color: #409eff;
}

.bp-order-st.st-done {
	background: rgba(82, 196, 26, 0.12);
	color: #52c41a;
}

.bp-order-st.st-cancel {
	background: rgba(255, 107, 107, 0.12);
	color: #ff6b6b;
}

.bp-order-txid {
	font-size: 12px;
	word-break: break-all;
	text-align: right;
}

.bp-order-unpaid {
	color: #ffa940;
}

.bp-order-paid {
	color: #52c41a;
}

.bp-order-none {
	padding: 12px;
	text-align: center;
	font-size: 12px;
	color: var(--im-text-color-light, #999);
}

/* 分配弹窗(与上粉群订单面板同口径) */
.dlg-line {
	display: flex;
	align-items: center;
	margin-bottom: 12px;
}

.dlg-line label {
	width: 86px;
	flex-shrink: 0;
	color: var(--im-text-color-light, #999);
	font-size: 13px;
}

.dlg-req {
	color: #f56c6c;
	font-style: normal;
	margin-right: 2px;
}

.dlg-opt {
	color: #909399;
	font-weight: normal;
}

.dlg-tip {
	font-size: 12px;
	color: var(--im-text-color-lighter, #bbb);
	margin-top: 4px;
}

/* 聊天记录识别的候选手机号:点选填充,选中态高亮 */
.dlg-phone-cands {
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}

.dlg-phone-cand {
	padding: 2px 10px;
	border-radius: 12px;
	background: #ecf5ff;
	color: #409eff;
	font-size: 12px;
	cursor: pointer;
	border: 1px solid transparent;
}

.dlg-phone-cand:hover {
	border-color: #409eff;
}

.dlg-phone-cand.active {
	background: #409eff;
	color: #fff;
}
</style>
